import { render, staticRenderFns } from "./BuilderBar.vue?vue&type=template&id=39ef5ee4&scoped=true&"
import script from "./BuilderBar.vue?vue&type=script&lang=js&"
export * from "./BuilderBar.vue?vue&type=script&lang=js&"
import style0 from "./BuilderBar.vue?vue&type=style&index=0&id=39ef5ee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ef5ee4",
  null
  
)

component.options.__file = "BuilderBar.vue"
export default component.exports